import * as React from "react";
import { PopupError } from '../presentational/PopupError';
import { connect } from 'react-redux';
import * as actions from '../actions/FormActions';
import { ErrorMessageService } from '../services/ErrorMessageService';

export interface PopupContainerProps {
    forms : any;
    setFormValues : any;
}
const mapStateToProps = (state: any) => {
    return {
        forms: state.forms
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setFormValues: (formName: string, values: any) => {
            dispatch(actions.storeFormValues(formName, values));
        }
    };
};

export class ContainedPopupContainer extends React.Component<PopupContainerProps> {
    render() {
        const popupText = {
            title: ErrorMessageService.errorMessageTitle(),
            message: ErrorMessageService.errorMessageDescription(this.props.forms['formGetApiError']),
            explanation: '',
            telephoneHint: ErrorMessageService.errorMessagePhoneNumberInfo(),
            telephoneNumber: ErrorMessageService.errorMessagePhoneNumber().replace(/ /g, ''),
            telephoneText: ErrorMessageService.errorMessagePhoneNumber(),
            okButtonText: ErrorMessageService.errorMessageButtonText(),
            linkUrl: '#',
            container: undefined,
            setFormValues: this.props.setFormValues
        };

        return (this.props.forms['formGetApiError'] ? (
                <PopupError {...popupText} stayOnPage={true} />
            ) : null);
    }
}

export const PopupContainer = connect(mapStateToProps, mapDispatchToProps)(ContainedPopupContainer);